<template>
  <v-row class="px-2">
    <v-col>
      <header1 class="mt-5">Lebenssäulen</header1>
      <div class="ml-5 mr-5 mt-5">
        <p class="body-2">Deine Lebenssäulen sind die verschiedenen Bereiche
          deines Lebens, die du mit <b class="dunkelblau--text">aimz</b> tracken
          kannst. Für eine bessere Einschätzung kannst du sie hier mit
          einer Wertigkeit versehen oder umbenennen.
        </p>
        <vc-donut class="mt-10 mb-3" :sections="donutValues" :has-legend="false" legend-placement="bottom">
          <span>Lebenssäulen</span><br>
          <span class="body-2">Was ist dir wichtiger?</span>
        </vc-donut>
        <template v-for="(section, i) in sections">
          <div class="d-flex mt-5">
            <span class="overline ml-2" :key="section.bid">{{bereichName(i, section)}} <v-badge v-if="!isAllowed(i)" class="ml-1 mr-8" color="blue" content="PRO"/></span>
            <v-btn text icon x-small class="ml-auto mr-1" @click="section.edit=!section.edit" :disabled="!isAllowed(i)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <v-row v-if="section.edit">
            <v-col :cols="6">
              <v-text-field v-model="section.customname" label="Lebenssäule" class="mx-2 mt-n3" :color="(section||[]).color||'pink'" @blur="onBlur(section)"></v-text-field>
            </v-col>
            <v-col :cols="6">
              <v-checkbox v-model="section.hide" class="mx-2 mt-n1" label="nicht verwenden" :color="(section||[]).color||'pink'" @click="update_sections"></v-checkbox>
            </v-col>
          </v-row>
          <v-slider class="my-auto mb-n5" v-model="getBereich(section.bid).value" :key="'slider_'+i" :color="(section||[]).color||'pink'" track-color="grey" always-dirty min="0" max="100"
                    :disabled="section.hide || !isAllowed(i)">
          </v-slider>
        </template>
        <template v-if="allow_save && isChanged">
          <center-container>
            <v-btn class="black" dark @click="save">Speichern</v-btn>
          </center-container>
        </template>
      </div>
      <div v-if="isFree" class="text-xl-center ml-6 mr-4">
        <div class="mt-3 pa-3" style="border: 1px dashed dodgerblue; width: calc( 100% - 8px); height: 220px; border-radius: 5px; background-color: #ffffff30">
          <span class="headline">Mehr Lebensbereiche?</span>
          <br/><br/> Go <pro/> für insgesamt 10 Lebensbereiche mit bis zu 100 Aktivitäten.
          <br/><br/>
          <v-btn rounded class="d-flex mx-10 gelb dunkelblau--text" href="https://www.digistore24.com/product/410225"
                 target="_blank">Upgrade auf aimz PRO</v-btn>
        </div>
      </div>
      <div class="d-flex">
        <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/pZ2-8hE5wxk" target="_blank">
          <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Header1 from "@/components/Header1";
import BEREICHE from "@/components/Bereiche";
import CenterContainer from "@/components/CenterContainer";
import Pro from "@/components/Pro";
const CONTEXT = "@erfolgsmatrix";

export default {
  name: "Erfolgsmatrix",
  components: {CenterContainer, Header1, Pro },
  props: ['allow_save'],
  data() {return {
    erfolgsmatrix_orig: {},
    erfolgsmatrix: {
    },
    donutValues:[],
    sections: [
      { value: 20, bid: BEREICHE.NAME_JOB,         color: BEREICHE.COLOR_JOB,         customname:"", edit:false, hide:false },
      { value: 20, bid: BEREICHE.NAME_GESUND,      color: BEREICHE.COLOR_GESUND,      customname:"", edit:false, hide:false },
      { value: 20, bid: BEREICHE.NAME_SOZIAL,      color: BEREICHE.COLOR_SOZIAL,      customname:"", edit:false, hide:false },
      { value: 20, bid: BEREICHE.NAME_ENTWICKLUNG, color: BEREICHE.COLOR_ENTWICKLUNG, customname:"", edit:false, hide:false },
      { value: 20, bid: BEREICHE.NAME_ICH,         color: BEREICHE.COLOR_ICH,         customname:"", edit:false, hide:false },
      { value: 0, bid: "b6", color: BEREICHE.COLORS[5], customname:"", edit:false, hide:true,  },
      { value: 0, bid: "b7", color: BEREICHE.COLORS[6], customname:"", edit:false, hide:true,  },
      { value: 0, bid: "b8", color: BEREICHE.COLORS[7], customname:"", edit:false, hide:true,  },
      { value: 0, bid: "b9", color: BEREICHE.COLORS[8], customname:"", edit:false, hide:true,  },
      { value: 0, bid: "b10", color: BEREICHE.COLORS[9], customname:"", edit:false, hide:true,  },
    ],
    isChanged:false,
  }},
  mounted() {
    this.isChanged=false;
    this.load();
  },
  methods: {
    update_sections() {
      for(var section of this.sections) {
        var bereich=this.getBereich(section.bid);
        bereich.ignore=section.hide;
        if (section.customname)
          bereich.name=section.customname;
      }
      var weights=BEREICHE.getWeights(this.erfolgsmatrix, this.numAllowed);
      var donut=[];
      for(var i=0;i<BEREICHE.NAMES.length; i++) {
        var bid=BEREICHE.NAMES[i];
        var section =this.sections[i];
        section.value=weights[bid]*100;
        if (section.value > 0)
          donut.push(this.sections[i]);
      }
      this.donutValues=donut;
    },
    async load() {
      this.loading = true;
      var data=await this.$backend.get_settings(CONTEXT, {onError: this.onLoadError});
      this.loading = false;
      if (data) {
        this.erfolgsmatrix_orig = data;
        this.erfolgsmatrix = Object.assign({}, this.erfolgsmatrix, JSON.parse(JSON.stringify(data)));
        this.$set(this.$app.user, 'erfolgsmatrix', data);
        console.log("erfolgsmatrix_orig", this.erfolgsmatrix_orig);
        console.log("erfolgsmatrix", this.erfolgsmatrix);
        for(var section of this.sections) {
          var bereich=this.getBereich(section.bid);
          if (!bereich.bid)
            continue;
          if (bereich.value===undefined)
            bereich.value=50;
          bereich.name||=bereich.bid;
          section.customname=bereich.name;
          section.hide=bereich.ignore;
        }
      }
      this.$nextTick(()=> this.isChanged=false);
    },
    onLoadError(reason) {
      this.loading = false;
      this.erfolgsmatrix = {};
      this.error = true;
      this.reason = reason;
    },
    getBereich(bid){
      return ((this.erfolgsmatrix||{}).bereiche||[]).filter(x=>x.bid===bid)[0] || {};
    },
    async save() {
      this.loading = true;
      this.sections.forEach(section=>{
        var bereich = this.getBereich(section.bid);
        if (section.bid && bereich){
          if (section.customname)
            bereich.name=section.customname
          bereich.ignore=section.hide;
        }
      });
      console.log("Saving erfolgsmatrix: ", this.erfolgsmatrix);
      await this.$backend.set_settings(CONTEXT, this.erfolgsmatrix, {
        onSuccess: this.onSaveSuccess,
        onError: this.onSaveError,
        no_notify:true,
      });
      this.load();
    },
    onSaveSuccess(data) {
      this.loading = false;
      this.erfolgsmatrix_orig = data;
      this.erfolgsmatrix = Object.assign({}, this.erfolgsmatrix, JSON.parse(JSON.stringify(data)));
    },
    onSaveError(reason) {
      this.loading = false;
      this.error = true;
      this.reason = reason;
      this.load();
    },
    onBlur(section) {
      if (!section.customname)
        section.customname=section.bid;
    },
    bereichName(i, section) {
      if (i==0)
        return section.customname;
      if (this.isGold)
        return section.customname;
      // if (this.isFree && i >= 0 && i < 5)
      //   return "Ab Silber-Abo";
      if (!this.isGold && i >= 5 && i < 10)
        return "Lebensbereich Nr " + (i+1);
      return section.customname;
    },
    isAllowed(i) {
      if (i===0)
        return true;
      if (this.isGold)
        return true;
      if (this.isFree && i >= 5)
        return false;
      if (this.isSilver && i >= 5)
        return false;
      return true;
    }
  },
  computed: {
    bereiche() {
      return BEREICHE.NAMES;
    },
    isFree() { return this.$app.isFree; },
    isSilver() { return this.$app.isSilver; },
    isGold() { return this.$app.isGold; },
    numAllowed() {
      if (this.isGold)
        return 10;
      if (this.isFree)
        return 5;
      if (this.isSilver)
        return 5;
      return 5;
    }
  },
  watch: {
    erfolgsmatrix: {
      deep:true,
      handler(n) {
        this.isChanged=(JSON.stringify(n)!==JSON.stringify(this.erfolgsmatrix_orig));
        //console.log("erfolgsmatrix changed")
        this.update_sections()
      },
    },
    sections: {
      deep:true,
      handler() {
        this.isChanged=true;
      },
    },
  }
}
</script>

<style scoped>

</style>